import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const DigilockerDownloadDocumentInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'Digilocker Download Document', subtitle: 'Download a specific document from Digilocker by file ID' }}
        fields={[
            { name: 'clientId', label: 'Client ID', icon: 'pi-key', placeholder: 'digilocker_xxxxxxxxx', maxLength: 100, mono: true },
            { name: 'fileId', label: 'File ID', icon: 'pi-file', placeholder: 'file_xxxxxxxxxxxxx', maxLength: 100, mono: true },
        ]}
        endpoint={{
            method: 'GET',
            path: '/surepass/digilocker/download-document',
            bodyMapper: (v, sid) => ({ client_id: v.clientId.trim(), file_id: v.fileId.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="digilocker-download-document"
        submitLabel="Download Document"
        successSummary="Document downloaded"
        errorSummary="Download failed"
        confirmHeader="Confirm document download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Digilocker Document', icon: 'pi-download' }}
    />
);

export default DigilockerDownloadDocumentInputComponent;
